import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "h-full pt-20 lg:pt-20 mx-auto" }
const _hoisted_2 = { class: "bg-white border border-gray-200 rounded-xl shadow-sm overflow-hidden p-4 mt-0 m-2" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("header", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "pi pi-user text-3xl m-4 text-[#36a8dd]" }),
  /*#__PURE__*/_createElementVNode("span", { class: "text-3xl" }, "Profile")
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "relative float-right" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "h-48 w-auto rounded-full",
    src: "https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_960_720.png",
    alt: ""
  })
], -1)
const _hoisted_5 = { class: "ml-8" }
const _hoisted_6 = { class: "flex flex-col gap-1" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", { for: "firstname" }, "First name", -1)
const _hoisted_8 = { class: "flex flex-col gap-1 my-4" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { for: "firstname" }, "Family name", -1)
const _hoisted_10 = { class: "flex flex-col gap-1" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { for: "firstname" }, "Email", -1)

import { ref, onMounted } from 'vue'
// import FileUpload from 'primevue/fileupload';
import InputText from 'primevue/inputtext';
import { authStore } from "../store/index";


export default /*#__PURE__*/_defineComponent({
  __name: 'ProfileView',
  setup(__props) {

const auth = authStore();

const user = ref({
    family_name: '',
    given_name: '',
    email:''
})

onMounted(async () => {
    Object.keys(user.value).forEach(key => {
        user.value[key] = auth.user.profile[key]
    });
    
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createVNode(_unref(InputText), {
            id: "firstname",
            modelValue: user.value.given_name,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((user.value.given_name) = $event)),
            class: "w-64 border",
            disabled: ""
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _createVNode(_unref(InputText), {
            id: "firstname",
            modelValue: user.value.family_name,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((user.value.family_name) = $event)),
            class: "w-64 border",
            disabled: ""
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _createVNode(_unref(InputText), {
            id: "firstname",
            modelValue: user.value.email,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((user.value.email) = $event)),
            class: "w-64 border",
            disabled: ""
          }, null, 8, ["modelValue"])
        ])
      ])
    ])
  ]))
}
}

})